import { forOwn, isEmpty } from 'utilities/helperFunctions';
let config = require('./environmentConfig');

/**
 * Replaces the parameters in the url for its values
 *
 * @example
 * buildUrl('http://localhost/users/{id}', {id: 123}); => 'http://localhost/users/123';
 */
function buildUrl(url, params) {
    if (!params || isEmpty(params)) {
        return url;
    }

    let urlWithParams = url;

    forOwn(params, (paramValue, paramName) => {
        urlWithParams = urlWithParams.replace(`{${paramName}}`, paramValue);
    });

    return urlWithParams;
}

/**
 * It adds a trailing slash if there isn't one
 */
function normalizeHost(host) {
    if (host.substr(-1) !== '/') {
        return `${host}/`;
    }

    return host;
}

/**
 * It removes the slash in the front of the endpoint if there is one
 */
function normalizeEndpoint(endpoint) {
    if (endpoint.substr(0, 1) === '/') {
        return endpoint.substr(1);
    }

    return endpoint;
}

function isMocked() {
    return config.services.mocked;
}

function setCustomConfig(_config) {
    config = _config;
}

function getHost(host) {
    return isMocked() ? config.services.hosts['mock'] : config.services.hosts[host];
}

/**
 * @param {string} endpointName Name of the endpoint
 * @param {object} params Object with the data needed to create the api url
 * @example { paramName: paramValue }
 */
function getURL(endpointName, params) {
    const endpoint = config.services.endpoints.find(endpoint => endpoint.name === endpointName);
    if (!endpoint || isEmpty(endpoint)) {
        throw new Error(`The endpoint ${endpointName} has not been found in the configuration`);
    }

    if (!endpoint.host) {
        throw new Error(`The endpoint ${endpoint.name} doesnt have a host defined`);
    }

    const host = isMocked() ? config.services.hosts['mock'] : config.services.hosts[endpoint.host];
    const url = normalizeHost(host) + normalizeEndpoint(endpoint.endpoint);
    const urlWithParams = buildUrl(url, params);

    if (urlWithParams.match(/{\w+}/g) && urlWithParams.match(/{\w+}/g).length > 0) {
        // if we still have a {} in the url, it means that some of the params hasn't
        // been sent with values. The url was not successfully created.
        // throw new EndpointNotCreated(url, params, endpoint);

        const missingParams = urlWithParams.match(/{\w+}/g).join(' ,');
        throw new Error(
            `The api url "${url}" could not be created since there are paramters missing: ${missingParams}`
        );
    }

    return urlWithParams;
}

export default {
    getURL,
    isMocked,
    setCustomConfig,
    getHost,
};
